var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamLogoPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72417 0.540045C9.9072 0.486627 10.1017 0.486652 10.2847 0.540117L19.2804 3.16794C19.7069 3.29252 20 3.68353 20 4.12782V9.51684C20 15.6116 16.0996 21.0224 10.3174 22.949C10.1123 23.0173 9.89046 23.0173 9.68528 22.949C3.90157 21.0224 0 15.6105 0 9.51435V4.12782C0 3.68344 0.293257 3.29236 0.719847 3.16787L9.72417 0.540045ZM2 4.8777V9.51435C2 14.6376 5.20889 19.1982 10.0013 20.9414C14.7922 19.1982 18 14.6388 18 9.51684V4.8775L10.0042 2.54175L2 4.8777Z",
    fill: "#101E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamLogoPlaceholder);
export default __webpack_public_path__ + "static/media/team-logo-placeholder.f6abc496152bf4af8bfb9f5c62d208b3.svg";
export { ForwardRef as ReactComponent };